import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import withWidth from "@material-ui/core/withWidth"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import {
  toggleProfileDialog,
  _updateUser,
  updateUser,
  createGalleryImage,
  removeGalleryImage,
  getUser,
  _setEditUser,
  toggleCreateCalendarDialog,
  getCalendar,
  createStripeAccount,
  toggleUserGTT,
  disconnectStripeAccount,
} from "../../actions/users"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import PositionChip from "./PositionChip"
import MapCard from "./MapCard"
import { isEmpty, pickBy, find, isNull, capitalize } from "lodash"
import Rating from "../Rating"
import Button from "@material-ui/core/Button"
import Avatar from "@material-ui/core/Avatar"
import AutoComplete from "../AutoComplete"
import TextField from "@material-ui/core/TextField"
import AddIcon from "@material-ui/icons/Add"
import update from "immutability-helper"
import {
  createRole,
  removeRole,
  createLocation,
  updateLocation,
  removeLocation,
  createEquipment,
  removeEquipment,
  createNote,
  removeNote,
  updateNote,
  createVehicle,
  uploadFile,
  createPhone,
  removePhone,
  createEmail,
  removeEmail,
  createWebsite,
  removeWebsite,
  updateRole,
  updateEquipment,
  addRating,
  createBadge,
  deleteBadge,
} from "../../actions/misc"
import { openSnackBar } from "../../actions/snack-bar"
import PlacesAutoComplete from "../PlacesAutoComplete"
import classNames from "classnames"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import VehicleCard from "./VehicleCard"
import MessageIcon from "@material-ui/icons/Message"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import Moment from "moment"
import Switch from "@material-ui/core/Switch"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { EditorState, convertToRaw, ContentState } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from "html-to-draftjs"
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import LoadingIconButton from "../LoadingIconButton"
import Cancel from "@material-ui/icons/Cancel"
import EliteImage from "../../assets/images/elite1.png"
import CircularProgress from "@material-ui/core/CircularProgress"
import InfoCircle from "../InfoCircle"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import CircleAvatar from "../CircleAvatar"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import "react-image-gallery/styles/css/image-gallery.css"
import ImageGallery from "react-image-gallery"
import CheckCircle from "@material-ui/icons/CheckCircle"
import serialize from "../../store/serialize"
import { pluralize } from "inflection"
import Modal from "@material-ui/core/Modal"
import AddressAutoComplete from "../AddressAutoComplete/index"
import Hidden from "@material-ui/core/Hidden"
// import {
//   setActiveChatter,
//   getMessages,
//   toggleMessageDrawer
// } from "../../actions/message-drawer"
import {
  toggleBookingDialog,
  toggleSuggestPositionDialog,
} from "../../actions/companies"
import Collapse from "@material-ui/core/Collapse"
import { Fab, List, ListItem } from "@material-ui/core"
import ArrowIcon from "@material-ui/icons/ArrowDropDown"
import LoadingIndicator from "../LoadingIndicator/index"
import PhoneInput from "../PhoneInput/index"
import InfoIcon from "../InfoIcon"
import { hiddenLoginModal } from "../../actions/authentication"
import copy from "copy-to-clipboard"
import IconButton from "@material-ui/core/IconButton"
import Icon from "@material-ui/core/Icon"
import CreateCalendarDialog from "../CreateCalendarDialog/index"
import { toggleShootDialog, setShootDialogCrew } from "../../actions/shoots"

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import CancelIcon from "@material-ui/icons/Cancel"
import TwitterIcon from "@material-ui/icons/Twitter"
import { handleConnect } from "../../utils/handleSocialConnect"
import { getCurrentHost } from "../../utils/getHost"
import { Box } from "../../../node_modules/@material-ui/core/index"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

var HtmlDiffer = require("html-differ").HtmlDiffer,
  htmlDiffer = new HtmlDiffer()

const toolBar = {
  options: ["inline", "list", "colorPicker", "link", "remove", "history"],
  inline: {
    options: ["bold", "italic", "underline"],
  },
  list: {
    options: ["unordered", "ordered"],
  },
}

const radiusSuggestions = [
  { id: 1, name: 30 },
  { id: 2, name: 45 },
  { id: 3, name: 65 },
  { id: 4, name: 100 },
]

class CopyButton extends Component {
  render() {
    return (
      <Fab
        style={{ width: "0px ", height: "0px" }}
        onClick={() => {
          copy(this.props.text)
          this.props.dispatch(
            openSnackBar({
              message: "Copied",
            })
          )
        }}
      >
        <img
          width="15"
          src="https://img.icons8.com/ios-glyphs/30/000000/copy.png"
          alt="copy"
        />
      </Fab>
    )
  }
}

const defaultState = {
  user: {
    first_name: "",
    last_name: "",
    description: "",
    video: "",
    crew_company: null,
    crew_company_id: null,
    phone: "",
    email: "",
    password: "",
    clients: "",
    route: "",
    street_number: "",
    city: "",
    state: "",
    zip: "",
    lat: "",
    lon: "",
    stripe_account: null,
    stripe_account_id: null,
  },
  clientsEditorContent: "",
  vehicle: {
    make: "",
    model: "",
    year: "",
  },
  savingProfile: false,
  role: {},
  location: {},
  equipment: {},
  rate: "",
  radius: null,
  activeTab: 0,
  removingPhones: [],
  removingEmails: [],
  removingWebsites: [],
  noteMenuAnchorEl: null,
  editingNote: null,
  noteEdits: "",
  galleryOpen: false,
  newPhone: "",
  newEmail: "",
  showPositions: false,
  showEquipment: false,
  hidePhone: false,
  hideEmail: false,
  setHiddenFields: false,
  hidePhones: [],
  hideEmails: [],
  canCreateCalendar: null,
  equipmentList: [],
}

class ProfileDialogComponent extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
    this.onDragEnd = this.onDragEnd.bind(this)
  }
  loadUserData = () => {
    if (Object.keys(this.props.user).length === 1) {
      this.props.dispatch(getUser(this.props.user.id, false)).then(res => {
        this.props.dispatch(_setEditUser(res))
        this.setValues()
      })
    } else {
      this.setValues()
    }
  }

  onEditorStateChange = editorState => {
    this.setState(
      update(this.state, {
        clientsEditorContent: {
          $set: editorState,
        },
        user: {
          clients: {
            $set: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          },
        },
      })
    )
  }
  handleClose = () => {
    if (this.props.user.id === this.props.authenticatedUser.id) {
      if (!this.props.user.has_password && !this.state.user.password) {
        document.getElementById("password").focus()
        this.props.dispatch(
          openSnackBar({
            message: "Please enter a password",
          })
        )
        return
      }
    }
    this.props.dispatch(toggleProfileDialog())
  }
  setValues = () => {
    let newState = update(this.state, {})
    if (!isEmpty(this.props.user)) {
      const {
        description,
        video,
        crew_company,
        crew_company_id,
        first_name,
        last_name,
        phone,
        email,
        clients,
        route,
        street_number,
        city,
        state,
        zip,
        lat,
        lon,
        equipment,
        stripe_account,
        stripe_account_id,
      } = this.props.user

      // client content conversion
      const contentState = ContentState.createFromBlockArray(
        htmlToDraft(clients).contentBlocks
      )
      newState = {
        ...newState,
        user: {
          ...this.state.user,
          description,
          video,
          crew_company,
          crew_company_id,
          first_name,
          last_name,
          phone,
          email,
          clients,
          route,
          street_number,
          city,
          state,
          zip,
          lat,
          lon,
          stripe_account,
          stripe_account_id,
        },
        equipmentList: equipment,
        clientsEditorContent: EditorState.createWithContent(contentState),
      }
    }
    this.setState(newState)
  }
  clearState = () => {
    this.setState(defaultState)
  }
  ratingChanged = value => {
    if (!this.props.authenticatedUser.id) {
      this.handleClose()
    }
    const user = this.props.user
    const id = user.id
    hiddenLoginModal()
      .then(_user => {
        if (_user.user) {
          _user = _user.user
        }
        let existingRating
        if (this.props.activeCompany) {
          existingRating = user.ratings.find(
            r => r.company_id === this.props.activeCompany
          )
        } else {
          existingRating = user.ratings.find(
            r => r.creator_id === this.props.authenticatedUser.id
          )
        }
        // const existingRating = .find(
        //   r =>
        //     r.company_id ===
        //       (isNaN(this.props.activeCompany)
        //         ? 0
        //         : this.props.activeCompany) && r.creator_id === _user.id
        // )
        let ratingId
        if (existingRating) {
          ratingId = existingRating.id
        }
        this.props.dispatch(
          addRating(
            value,
            ratingId,
            user.id,
            this.props.authenticatedUser,
            this.props.activeCompany || 0
          )
        )
      })
      .catch(err => {
        this.props.dispatch(
          toggleProfileDialog(true, {
            id,
          })
        )
      })
  }

  onAutoCompleteChange = async (val, name) => {
    if (name === "role") {
      let roleValue = { id: val.id, name: val.name }
      // await this.setState({ role: this.props.roles.find(n => n.id === val) })
      await this.setState({ role: roleValue })
    } else if (name === "equipment") {
      this.setState(
        update(this.state, {
          [name]: {
            $set: this.props[`${pluralize(name)}`].find(n => n.id === val)
              ? this.props[`${pluralize(name)}`].find(n => n.id === val)
              : val,
          },
        })
      )
    } else {
      this.setState(
        update(this.state, {
          [name]: {
            $set: this.props[`${pluralize(name)}`].find(n => n.id === val),
          },
        })
      )
    }

    // if (name === "role" && document.getElementById("rate-input")) {
    //   document.getElementById("rate-input").focus()
    // }
  }
  onDelete = (data, name) => {
    // this.setState(update(this.state, {
    //   user: {
    //     [name]: {
    //       '$set': this.state.user[name].filter((s) => s[propName] !== data[propName])
    //     }
    //   }
    // }))
    if (name === "locations") {
      this.props
        .dispatch(removeLocation(data.id, this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              locations: this.props.user.locations.filter(
                l => l.id !== data.id
              ),
            })
          )
        })
    } else if (name === "equipment") {
      this.props
        .dispatch(removeEquipment(data.id, this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: this.props.user.equipment.filter(
                l => l.id !== data.id
              ),
            })
          )
        })
    } else if (name === "notes") {
      this.props.dispatch(removeNote(data.id, this.props.user.id)).then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.filter(l => l.id !== data.id),
          })
        )
      })
    } else {
      this.props.dispatch(removeRole(data.id, this.props.user.id)).then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            roles: this.props.user.roles.filter(r => r.id !== data.id),
          })
        )
      })
    }
  }
  onPlacesChange = place => {
    this.setState(
      update(this.state, {
        location: {
          $set: place,
        },
      })
    )
    document.querySelector("#radius-input input").focus()
  }
  onAddressChange = place => {
    let updates = {}
    for (const key in place) {
      updates[key] = {
        $set: place[key] || "",
      }
    }
    this.setState(
      update(this.state, {
        user: {
          ...updates,
        },
      })
    )
  }
  savePosition = e => {
    e.preventDefault()
    //add logic for if they have a subscription
    if (this.props.activeCompany !== 3) {
      if (!this.props.user.membershipValid) {
        if (this.props.user.roles.length >= 2) {
          this.props.dispatch({
            type: "PAYMENT_MODAL",
            payload: true,
          })
          return
        }
      }
    }
    this.setState({ savingPosition: true })
    let data = { ...this.state.role, rate: this.state.rate }
    if (data.hasOwnProperty("className")) {
      delete data.className
      delete data.id
    }
    let functionName = createRole
    let params = [data, this.props.user.id]
    const existingPosition = this.props.user.roles.find(
      l => l.name === data.name
    )
    if (existingPosition) {
      functionName = updateRole
      params.splice(1, 0, existingPosition.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Position Saved",
          })
        )
        if (existingPosition) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              roles: this.props.user.roles.map(p => {
                if (p.id === existingPosition.id) {
                  p = {
                    ...p,
                    ...data,
                    id: res.id,
                  }
                }
                return p
              }),
            })
          )
        } else {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              roles: [
                ...this.props.user.roles,
                {
                  ...data,
                  id: res.id,
                },
              ],
            })
          )
        }
        this.setState({ savingPosition: false })
        setTimeout(() => {
          this.setState({
            role: {},
            rate: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving position",
          })
        )
        this.setState({ savingPosition: false })
      })
  }
  saveLocation = e => {
    e.preventDefault()
    if (this.props.activeCompany !== 3) {
      if (!this.props.user.membershipValid) {
        if (this.props.user.locations.length >= 2) {
          this.props.dispatch({
            type: "PAYMENT_MODAL",
            payload: true,
          })
          return
        }
      }
    }
    this.setState({ savingLocation: true })
    let functionName = createLocation
    let params = [
      {
        ...this.state.location,
        work_radius: parseInt(this.state.radius.name, 10),
      },
      this.props.user.id,
    ]
    const existingLocation = this.props.user.locations.find(l => {
      if (this.state.location.country === "United States") {
        return (
          l.city === this.state.location.city &&
          l.state === this.state.location.state
        )
      } else {
        return (
          l.city === this.state.location.city &&
          l.country === this.state.location.country
        )
      }
    })
    if (existingLocation) {
      functionName = updateLocation
      params.splice(1, 0, existingLocation.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.setState({ savingLocation: false })
        if (existingLocation) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              locations: this.props.user.locations.map(l => {
                if (l.id === existingLocation.id) {
                  l = {
                    ...l,
                    ...this.state.location,
                    work_radius: this.state.radius.name,
                    id: res.id,
                  }
                }
                return l
              }),
            })
          )
        } else {
          serialize("location", {
            ...this.state.location,
            work_radius: this.state.radius.name,
            id: res.id,
          }).then(locationData => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                locations: [...this.props.user.locations, locationData],
              })
            )
          })
        }
        setTimeout(() => {
          this.setState({
            location: {},
            radius: radiusSuggestions[1],
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving location",
          })
        )
        this.setState({ savingLocation: false })
      })
  }
  saveEquipment = (e = null) => {
    if (e) {
      e.preventDefault()
    }
    if (this.props.activeCompany !== 3) {
      if (!this.props.user.membershipValid) {
        if (this.props.user.equipment.length >= 4) {
          this.props.dispatch({
            type: "PAYMENT_MODAL",
            payload: true,
          })
          return
        }
      }
    }
    this.setState({ savingEquipment: true })
    let data = this.state.equipment
    if (data.hasOwnProperty("className")) {
      delete data.className
      delete data.id
    }
    let functionName = createEquipment
    let params = [data, this.props.user.id]
    const existingEquipment = this.props.user.equipment.find(
      l => l.name === data.name
    )
    if (existingEquipment) {
      functionName = updateEquipment
      params.splice(1, 0, existingEquipment.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Equipment Saved",
          })
        )
        if (existingEquipment) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: this.props.user.equipment.map(e => {
                if (e.id === existingEquipment.id) {
                  e = {
                    ...e,
                    ...data,
                    id: res.id,
                  }
                }
                return e
              }),
            })
          )
        } else {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: [
                ...this.props.user.equipment,
                {
                  ...data,
                  id: res.id,
                },
              ],
            })
          )
        }
        this.setState({ savingEquipment: false })
        setTimeout(() => {
          this.setState({
            equipment: {},
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving equipment",
          })
        )
        this.setState({ savingEquipment: false })
      })
  }
  saveNote = () => {
    this.setState({ savingNote: true })
    this.props
      .dispatch(createNote({ note: this.state.note }, this.props.user.id))
      .then(res => {
        this.setState({ savingNote: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: [
              ...this.props.user.notes,
              {
                note: this.state.note,
                creator_id: this.props.authenticatedUser.id,
                creator_first_name: this.props.authenticatedUser.first_name,
                creator_last_name: this.props.authenticatedUser.last_name,
                creator_profile_image: this.props.authenticatedUser
                  .profile_image,
                created: Moment().utc(),
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            note: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving note",
          })
        )
        this.setState({ savingNote: false })
      })
  }
  handleOpenNoteMenu = e => {
    this.setState({ noteMenuAnchorEl: e.currentTarget })
  }
  handleCloseNoteMenu = () => {
    this.setState({ noteMenuAnchorEl: null })
  }
  handleNoteMenuItemClick = (action, note) => {
    this.handleCloseNoteMenu()
    if (action === "edit") {
      this.setState({ editingNote: note.id, noteEdits: note.note })
    } else if (action === "cancelEdit") {
      this.setState({ editingNote: null, noteEdits: "" })
    } else {
      this.removeNote(note)
    }
  }
  updateNote = () => {
    this.setState({ updatingNote: true })
    this.props
      .dispatch(
        updateNote(
          { note: this.state.noteEdits },
          this.state.editingNote,
          this.props.user.id
        )
      )
      .then(res => {
        this.setState({ updatingNote: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.map(note => {
              if (note.id === this.state.editingNote) {
                note = {
                  ...note,
                  note: this.state.noteEdits,
                  updated: Moment().utc(),
                }
              }
              return note
            }),
          })
        )
        setTimeout(() => {
          this.setState({
            noteEdits: "",
            editingNote: null,
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error updating note",
          })
        )
        this.setState({ updatingNote: false })
      })
  }
  removeNote = note => {
    this.props
      .dispatch(removeNote(note.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.filter(n => n.id !== note.id),
          })
        )
        setTimeout(() => {}, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error deleting note",
          })
        )
      })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    let value = e.target.value
    if (fieldName === "video" && value.match(/^https?:\/\//)) {
      value = value.replace(/^https?:\/\/vimeo.com\//, "")
    }

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value },
      },
      // form: {
      //   [fieldName]: {
      //     validity: { $set: validity }
      //   }
      // }
    })
    // newState.form.valid = this.formIsValid(newState.form);
    this.setState(newState)
  }

  changeGoToTeam = e => {
    let data = { go_to_team: e.target.checked }
    this.props
      .dispatch(toggleUserGTT(this.props.user.id, data))
      .then(res => {
        let newState = update(this.state, {
          user: {
            crew_company: {
              $set: data.go_to_team ? "Go To Team" : null,
            },
            crew_company_id: { $set: data.go_to_team ? 3 : 0 },
          },
        })
        this.setState(newState)

        this.props.dispatch(openSnackBar({ message: "GTT toggle updated" }))
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({ message: "Error updating gtt toggle" })
        )
      })
  }
  handleNewInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    this.setState(
      update(this.state, {
        [fieldName]: {
          $set: value,
        },
      })
    )
  }
  handleNewPhoneChange = value => {
    this.setState(
      update(this.state, {
        newPhone: {
          $set: value,
        },
      })
    )
  }
  handlePhoneChange = value => {
    this.setState(
      update(this.state, {
        user: {
          phone: { $set: value },
        },
      })
    )
  }
  getDiff = () =>
    pickBy(this.state.user, (val, key) => {
      if (key === "clients") {
        return !htmlDiffer.isEqual(val, this.props.user[key])
      } else if (key === "password") {
        return val !== ""
      } else if (key === "phone") {
        return val !== this.props.user.formattedPhone
      } else {
        return val !== this.props.user[key]
      }
    })
  submit = bool => {
    if (
      !this.props.user.has_password &&
      !this.state.user.password &&
      this.props.user.id === this.props.authenticatedUser.id
    ) {
      document.getElementById("password").focus()
      this.props.dispatch(
        openSnackBar({
          message: "Please enter a password",
        })
      )
      return
    }
    this.setState({
      savingProfile: true,
    })
    const updates = this.getDiff()
    if (updates.hasOwnProperty("clients")) {
      const startingClients = updates.clients
      try {
        updates.clients = updates.clients.replace(/<a\s/g, '<a rel="nofollow" ')
      } catch (err) {
        updates.clients = startingClients
      }
      // updates.clients = draftToHtml(convertToRaw(this.state.user.clients.getCurrentContent()))
    }
    updates.hidden_fields = JSON.stringify({
      phone: this.state.hidePhone,
      email: this.state.hideEmail,
      emails: this.state.hideEmails,
      phones: this.state.hidePhones,
    })

    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        let has_password = this.props.user.has_password
        if (this.state.user.password) {
          has_password = true
        }
        this.props.dispatch(
          _updateUser({ ...updates, id: this.props.user.id, has_password })
        )
        // !bool &&
        this.props.dispatch(
          openSnackBar({
            message: "Crew member updated",
          })
        )
        this.setState({
          savingProfile: false,
        })

        // !bool &&
        this.handleClose()
      })
      .catch(err => {
        const error = err.response.body.error
        let message = "There was an error updating this crew member"
        if (error && error.code && error.code === "ER_DUP_ENTRY") {
          if (error.sqlMessage.indexOf("for key 'phone'") > -1) {
            message = "That phone number is already in use"
          }
        }
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
      })
  }
  updateVehicle = e => {
    this.setState(
      update(this.state, {
        vehicle: {
          [e.target.name]: {
            $set: e.target.value,
          },
        },
      })
    )
  }
  saveVehicle = e => {
    e.preventDefault()
    if (this.props.activeCompany !== 3) {
      if (!this.props.user.membershipValid) {
        if (this.props.user.vehicles.length >= 1) {
          this.props.dispatch({
            type: "PAYMENT_MODAL",
            payload: true,
          })
          return
        }
      }
    }
    this.setState({ savingVehicle: true })
    this.props
      .dispatch(createVehicle(this.state.vehicle, this.props.user.id))
      .then(res => {
        this.setState({ savingVehicle: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            vehicles: [
              ...this.props.user.vehicles,
              {
                ...this.state.vehicle,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            vehicle: {
              make: "",
              model: "",
              year: "",
            },
            showAddVehicle: false,
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving vehicle",
          })
        )
        this.setState({ savingVehicle: false })
      })
  }
  avatarChanged = e => {
    const file = e.target.files[0]
    this.setState({ uploadingAvatar: true })
    this.props
      .dispatch(uploadFile(file, `users/${this.props.user.id}/profile_images`))
      .then(image => {
        this.props
          .dispatch(
            updateUser(this.props.user.id, {
              profile_image: JSON.stringify(image),
            })
          )
          .then(() => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                profile_image: image,
              })
            )
            this.setState({ uploadingAvatar: false })
            document.getElementById("profileImage").value = ""
          })
          .catch(err => {
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving avatar",
              })
            )
            this.setState({ uploadingAvatar: false })
            document.getElementById("profileImage").value = ""
          })
      })
      .catch(err => {
        this.setState({ uploadingAvatar: false })
        document.getElementById("profileImage").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving avatar",
          })
        )
      })
  }
  handleTabChange = (event, activeTab) => {
    const { user, authenticatedUser } = this.props
    const isMe = user.id === authenticatedUser.id
    this.setState({ event })
    if (!isMe) {
      this.setState({ activeTab })
    }

    if (user.crew_company_id === 3) {
      this.setState({ activeTab })
    } else {
      if (this.props.activeCompany !== 3) {
        if (!this.props.user.membershipValid) {
          if (activeTab >= 1) {
            this.props.dispatch({
              type: "PAYMENT_MODAL",
              payload: true,
            })
            return
          } else {
            this.setState({ activeTab })
          }
        } else {
          this.setState({ activeTab })
        }
      } else {
        this.setState({ activeTab })
      }
    }
  }

  handlePublicChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      public: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ public: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.public
              ? "Profile set to public"
              : "Profile set to private",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting this profile to ${
              updates.public ? "public" : "private"
            }`,
          })
        )
      })
  }

  handleSocialConnectSwitch = (e, network, networkId) => {
    const data = {
      creator_id: this.props.authenticatedUser.id,
      network_id: networkId,
    }

    handleConnect(network, this.props.user.id, data)
  }

  handleLaborOnlyChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      labor_only: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ labor_only: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.labor_only
              ? "Profile set to labor only"
              : "Profile set to not labor only",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting labor only`,
          })
        )
      })
  }
  handleVaccinatedChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      vaccinated: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ vaccinated: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.vaccinated
              ? "Profile set to vaccinated"
              : "Profile set to not vaccinated",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting vaccinated`,
          })
        )
      })
  }
  handleEliteChanged = e => {
    const isChecked = e.target.checked

    if (!isChecked) {
      this.props
        .dispatch(deleteBadge(this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({ badges: [], id: this.props.user.id })
          )
          this.props.dispatch(
            openSnackBar({
              message: "Profile set to not elite",
            })
          )
        })
        .catch(err => {
          console.log(err)
          this.props.dispatch(
            openSnackBar({
              message: `There was an error deleting elite`,
            })
          )
        })
    } else {
      this.props
        .dispatch(createBadge(this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({
              badges: [{ name: "Elite", id: 1 }],
              id: this.props.user.id,
            })
          )
          this.props.dispatch(
            openSnackBar({
              message: "Profile set to elite",
            })
          )
        })
        .catch(err => {
          console.log(err)
          this.props.dispatch(
            openSnackBar({
              message: `There was an error setting elite`,
            })
          )
        })
    }
  }
  addNewPhone = e => {
    e.preventDefault()
    if (this.state.newPhone === this.state.user.phone) {
      this.props.dispatch(
        openSnackBar({
          message: "Phone number is already your primary number",
        })
      )
      return
    }
    this.setState({ addingNewPhone: true })
    this.props
      .dispatch(createPhone({ phone: this.state.newPhone }, this.props.user.id))
      .then(res => {
        this.setState({ addingNewPhone: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            phones: [
              ...this.props.user.phones,
              {
                phone: this.state.newPhone,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newPhone: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving phone number",
          })
        )
        this.setState({ addingNewPhone: false })
      })
  }
  removePhone = phone => {
    this.setState(
      update(this.state, {
        removingPhones: {
          $push: [phone.id],
        },
      })
    )
    this.props.dispatch(removePhone(phone.id, this.props.user.id)).then(res => {
      this.props.dispatch(
        _updateUser({
          id: this.props.user.id,
          phones: this.props.user.phones.filter(l => l.id !== phone.id),
        })
      )
      this.setState(
        update(this.state, {
          removingPhones: {
            $set: this.state.removingPhones.filter(l => l !== phone.id),
          },
        })
      )
    })
  }
  addNewEmail = e => {
    e.preventDefault()
    if (this.state.newEmail === this.state.user.email) {
      this.props.dispatch(
        openSnackBar({
          message: "Email is already your primary email",
        })
      )
      return
    }
    this.setState({ addingNewEmail: true })
    this.props
      .dispatch(createEmail({ email: this.state.newEmail }, this.props.user.id))
      .then(res => {
        this.setState({ addingNewEmail: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            emails: [
              ...this.props.user.emails,
              {
                email: this.state.newEmail,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newEmail: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving email address",
          })
        )
        this.setState({ addingNewEmail: false })
      })
  }
  removeEmail = email => {
    this.setState(
      update(this.state, {
        removingEmails: {
          $push: [email.id],
        },
      })
    )
    this.props.dispatch(removeEmail(email.id, this.props.user.id)).then(res => {
      this.props.dispatch(
        _updateUser({
          id: this.props.user.id,
          emails: this.props.user.emails.filter(l => l.id !== email.id),
        })
      )
      this.setState(
        update(this.state, {
          removingEmails: {
            $set: this.state.removingEmails.filter(l => l !== email.id),
          },
        })
      )
    })
  }

  hideOtherEmail = emailId => {
    if (this.state.hideEmails.indexOf(emailId) > -1) {
      this.setState({
        hideEmails: this.state.hideEmails.filter(x => x !== emailId),
      })
    } else {
      this.setState({
        hideEmails: this.state.hideEmails.concat(emailId),
      })
    }
  }

  addNewWebsite = e => {
    e.preventDefault()
    this.setState({ addingNewWebsite: true })
    this.props
      .dispatch(
        createWebsite({ website: this.state.newWebsite }, this.props.user.id)
      )
      .then(res => {
        this.setState({ addingNewWebsite: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            websites: [
              ...this.props.user.websites,
              {
                website: this.state.newWebsite,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newWebsite: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving website",
          })
        )
        this.setState({ addingNewWebsite: false })
      })
  }
  removeWebsite = website => {
    this.setState(
      update(this.state, {
        removingWebsites: {
          $push: [website.id],
        },
      })
    )
    this.props
      .dispatch(removeWebsite(website.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            websites: this.props.user.websites.filter(l => l.id !== website.id),
          })
        )
        this.setState(
          update(this.state, {
            removingWebsites: {
              $set: this.state.removingWebsites.filter(l => l !== website.id),
            },
          })
        )
      })
  }
  // shouldShowControls = key => {
  //   const user = this.props.user
  //   if (!isEmpty(this.props.user) && this.props.authenticatedUser.id) {
  //     if (
  //       this.props.accessLevel === 1 &&
  //       user.companies &&
  //       user.companies[0] &&
  //       user.companies[0].id == this.props.activeCompany
  //     ) {
  //       return true
  //     } else {
  //       return false
  //     }
  //   } else {
  //     return false
  //   }
  // }

  shouldShowControls = key => {
    // console.log(this.props.authenticatedUser)
    if (this.props.activeCompany && this.props.activeCompany === 3) {
      return true
    }
    if (this.props.user.id === this.props.authenticatedUser.id) {
      return true
    }
    if (
      !isEmpty(this.props.user) &&
      this.props.authenticatedUser.id &&
      this.props.activeCompany &&
      this.props.accessLevel === 1
    ) {
      if (this.props.user[key].length > 0) {
        if (
          this.props.user[key].filter(x => x.creator_id === this.props.user.id)
            .length === 0
        ) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    } else {
      return false
    }
  }

  // company can edit

  // shouldShowControlls = key => {
  //   if (!isEmpty(this.props.user) && this.props.authenticatedUser.id) {
  //     if (this.props.user.id === this.props.authenticatedUser.id) {
  //       return true
  //     } else if () {

  //     }
  //   } else {
  //     return false
  //   }
  // }

  generateAvatar = () => {
    if (!isEmpty(this.props.user)) {
      if (!isEmpty(this.props.user.profile_image)) {
        return (
          <img
            className={this.props.classes.avatarImage}
            src={`https://res.cloudinary.com/${
              process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,g_face:auto,z_0.7,h_400,w_400,fl_lossy,f_auto/v${
              this.props.user.profile_image.version
            }/${this.props.user.profile_image.public_id}.${
              this.props.user.profile_image.format
            }`}
            alt={`${this.props.user.first_name} ${this.props.user.last_name}`}
          />
        )
      } else {
        return (
          <Avatar className={this.props.classes.avatar}>
            {this.props.user.first_name.charAt(0)}
            {this.props.user.last_name.charAt(0)}
          </Avatar>
        )
      }
    }
  }
  clickGalleryImageInput = e => {
    e.preventDefault()
    document.getElementById("galleryImage").click()
  }
  galleryUpload = e => {
    const file = e.target.files[0]
    this.setState({ uploadingGalleryImage: true })
    this.props
      .dispatch(uploadFile(file, `users/${this.props.user.id}/gallery_images`))
      .then(image => {
        this.props
          .dispatch(
            createGalleryImage(
              {
                image: JSON.stringify(image),
              },
              this.props.user.id
            )
          )
          .then(res => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                gallery: [
                  ...this.props.user.gallery,
                  {
                    image,
                    id: res.id,
                  },
                ],
              })
            )
            this.setState({ uploadingGalleryImage: false })
            document.getElementById("galleryImage").value = ""
          })
          .catch(err => {
            this.setState({ uploadingGalleryImage: false })
            document.getElementById("galleryImage").value = ""
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving gallery image",
              })
            )
          })
      })
      .catch(err => {
        this.setState({ uploadingGalleryImage: false })
        document.getElementById("galleryImage").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving gallery image",
          })
        )
      })
  }
  removeGalleryImage = image => {
    this.props
      .dispatch(removeGalleryImage(image.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            gallery: this.props.user.gallery.filter(g => g.id !== image.id),
          })
        )
      })
  }
  openGallery = index => {
    this.setState({ galleryOpen: true })
    setTimeout(() => {
      this._imageGallery.slideToIndex(index)
    }, this.props.theme.transitions.duration.enteringScreen + 100)
  }

  openCreateCalendarDialog = () => {
    this.props.dispatch(toggleCreateCalendarDialog(true, this))
    this.props
      .dispatch(getCalendar(this.props.user.id))
      .then(res => {
        // debugger;
        if (res === true) {
          this.setState({ canCreateCalendar: true })
        } else {
          this.setState({ canCreateCalendar: false })
        }
      })
      .catch(err => console.log(err))
  }

  async onDragEnd(result) {
    const { user } = this.props
    const equipmentTarget = await find(
      user.equipment,
      uq => uq.id === parseInt(result.draggableId)
    )

    equipmentTarget.position = result.destination.index + 1

    let params = [equipmentTarget, this.props.user.id]

    params.splice(1, 0, equipmentTarget.id)

    this.props.dispatch(updateEquipment(...params)).then(res => {
      this.props.dispatch(
        openSnackBar({
          message: "Equipment Updated",
        })
      )
      this.props.dispatch(
        _updateUser({
          id: this.props.user.id,
          equipment: this.props.user.equipment.map(e => {
            if (e.id === equipmentTarget.id) {
              e = {
                ...e,
                ...equipmentTarget,
                id: res.id,
              }
            }
            return e
          }),
        })
      )
    })
  }

  disconnectUserStripe = () => {
    let stripeId = this.props.authenticatedUser.stripe_account_id
    this.props
      .dispatch(disconnectStripeAccount(stripeId))
      .then(res => {
        this.setState({
          user: {
            ...this.state.user,
            stripe_account_id: null,
            stripe_account: 0,
          },
        })
        this.props.dispatch(
          openSnackBar({ message: "Disconnect from stripe successfully" })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({ message: "Error disconnecting from stripe" })
        )
      })
  }

  render() {
    const {
      fullScreen,
      classes,
      user,
      networks,
      history,
      accessLevel,
      activeCompany,
    } = this.props
    const {
      hideEmail,
      hidePhone,
      setHiddenFields,
      hidePhones,
      hideEmails,
    } = this.state
    const isNotInSolos =
      !history.location.pathname.includes("solo-invoice") &&
      !history.location.pathname.includes("solo-estimate")

    const isNotInShoots =
      getCurrentHost() === "crewmama" &&
      this.props.history.location.pathname.includes("shoots")
    const isMe = user.id === this.props.authenticatedUser.id
    //const isPaid = user.payments.length > 0
    const isNotMe = user.id !== this.props.authenticatedUser.id
    const { noteMenuAnchorEl } = this.state
    let companyRating = undefined
    let myRating = undefined
    let selectedRating = 0
    if (!isEmpty(user) && Object.keys(user).length > 1) {
      if (this.props.accessLevel === 1) {
        companyRating = user.ratings.find(
          r => r.company_id === this.props.activeCompany
        )
      }
      myRating = user.ratings.find(
        r =>
          r.creator_id === this.props.authenticatedUser.id && r.company_id === 0
      )
      if (companyRating) {
        selectedRating = companyRating.score
      } else if (myRating) {
        selectedRating = myRating.score
      }
    }
    const positionCollapse = document.querySelector(
      "#position-collapse > div > div"
    )
    const equipmentCollapse = document.querySelector(
      "#equipment-collapse > div > div"
    )
    if (!setHiddenFields && user && user.hidden_fields) {
      this.setState({ setHiddenFields: true })
      try {
        let hidden_fields = JSON.parse(user.hidden_fields)
        this.setState({
          hidePhone: hidden_fields.phone,
          hideEmail: hidden_fields.email,
          hidePhones: hidden_fields.phones || [],
          hideEmails: hidden_fields.emails || [],
        })
      } catch (err) {}
    }

    let isDisabled = false

    if (user.crew_company_id !== 3) {
      if (isNotMe && this.props.activeCompany !== 3 && !user.membershipValid) {
        isDisabled = true
      }
    }

    return (
      <Fragment>
        <Dialog
          className={classes.profileDialog}
          fullScreen={fullScreen}
          open={this.props.profileDialogOpen}
          onClose={this.handleClose}
          onEntered={this.loadUserData}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper,
            },
          }}
        >
          {!isEmpty(user) &&
            Object.keys(user).length > 1 && (
              <Fragment>
                <DialogContent className={classes.dialogContent}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={4}>
                      <Fragment>
                        <Paper eleation={2} className={classes.avatarPaper}>
                          <div
                            className={classNames(classes.avatarWrapper, {
                              [this.props.classes.imageOverlay]:
                                selectedRating === 6 || selectedRating === -1,
                              [this.props.classes.imageOverlayPreferred]:
                                selectedRating === 6,
                              [this.props.classes.imageOverlayDoNotUse]:
                                selectedRating === -1,
                            })}
                          >
                            {this.state.uploadingAvatar && (
                              <div className={classes.avatarUploadOverlay}>
                                <CircularProgress
                                  color="inherit"
                                  className={classes.avatarUploadProgress}
                                />
                              </div>
                            )}
                            {(isMe || this.props.activeCompany === 3) && (
                              <label
                                htmlFor="profileImage"
                                className={classes.avatarLabel}
                              >
                                {!this.state.uploadingAvatar && (
                                  <div className={classes.addImageOverlay}>
                                    <AddPhotoAlternate
                                      className={classes.addPhotoIcon}
                                    />
                                  </div>
                                )}
                                {this.generateAvatar()}
                                <input
                                  type="file"
                                  id="profileImage"
                                  name="profileImage"
                                  className={classes.avatarInput}
                                  value={this.state.profileImage}
                                  onChange={this.avatarChanged}
                                />
                              </label>
                            )}
                            {isNotMe && this.generateAvatar()}
                          </div>
                          {!isEmpty(user) &&
                            user.badges.length > 0 && (
                              <div className={this.props.classes.badgeWrapper}>
                                <img
                                  src={EliteImage}
                                  className={this.props.classes.badgeImage}
                                  alt="Elite"
                                />
                              </div>
                            )}
                        </Paper>
                        {(isMe || this.props.activeCompany === 3) && (
                          <Fragment>
                            <Grid
                              container
                              spacing={2}
                              className={classes.nameInputs}
                            >
                              <Grid item xs={6}>
                                <FormControl
                                  fullWidth
                                  className={classes.marginBottom}
                                >
                                  <TextField
                                    type="text"
                                    fullWidth
                                    name="first_name"
                                    label="First Name"
                                    value={this.state.user.first_name}
                                    onChange={this.handleInputChange}
                                    id="first_name"
                                    autoComplete="nope"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <FormControl
                                  fullWidth
                                  className={classes.marginBottom}
                                >
                                  <TextField
                                    type="text"
                                    fullWidth
                                    name="last_name"
                                    label="Last Name"
                                    value={this.state.user.last_name}
                                    onChange={this.handleInputChange}
                                    id="last_name"
                                    autoComplete="nope"
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>

                            {activeCompany === 3 &&
                              accessLevel === 1 && (
                                <FormControl
                                  fullWidth
                                  className={classes.marginBottom}
                                >
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={
                                          this.state.user.crew_company_id === 3
                                            ? true
                                            : false
                                        }
                                        onChange={this.changeGoToTeam}
                                        name="crew_company_id"
                                      />
                                    }
                                    label="Go To Team"
                                  />
                                </FormControl>
                              )}
                          </Fragment>
                        )}
                        {isNotMe && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              alignItems: "center",
                            }}
                          >
                            <h2
                              style={{
                                fontFamily: "Open Sans, sans-serif",
                                fontWeight: 300,
                                margin: 0,
                                marginRight: "12px",
                              }}
                            >
                              {user.first_name} {user.last_name}
                            </h2>
                            <CopyButton
                              text={
                                user.first_name +
                                " " +
                                user.last_name +
                                " - " +
                                user.email +
                                " - " +
                                user.phone.replace(
                                  /^[+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                  "$1-$2-$3"
                                ) +
                                "\n" +
                                "https://crewmama.com/" +
                                user.id
                              }
                              dispatch={this.props.dispatch}
                            />
                          </div>
                        )}
                        {isNotMe && (
                          <h3
                            style={{
                              fontFamily: "Open Sans, sans-serif",
                              fontWeight: 300,
                              margin: 0,
                              marginRight: "12px",
                            }}
                          >
                            {user.crew_company_id === 3 && "Go To Team"}
                          </h3>
                        )}
                        {!isEmpty(user) &&
                          isNotMe && (
                            <div className={classes.rating}>
                              <Rating
                                avgRating={user.avg_rating}
                                userId={user.id}
                                totalRatings={
                                  user.ratings.filter(r => r.score > -1).length
                                }
                                selectedRating={selectedRating}
                                ratingChanged={this.ratingChanged}
                              />
                            </div>
                          )}
                        {/* {isMe && this.props.user.hasMembership ? (
                          this.props.user.membershipValid ? (
                            <Button
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.dispatch({
                                  type: "CANCEL_SUBSCRIPTION_MODAL",
                                  payload: {
                                    open: true,
                                    user: this.props.user,
                                  },
                                })
                              }}
                            >
                              Cancel Subscription
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.dispatch({
                                  type: "ALREADY_CANCELED_SUBSCRIPTION_MODAL",
                                  payload: {
                                    open: true,
                                    user: this.props.user,
                                  },
                                })
                              }}
                            >
                              Cancel Subscription
                            </Button>
                          )
                        ) : null} */}
                        {isMe ||
                          (user.phones.filter(
                            x =>
                              isMe ||
                              this.props.activeCompany ||
                              hidePhones.indexOf(x.id) === -1
                          ).length > 0 && (
                            <div
                              className={classNames(
                                classes.headlineWrapper,
                                classes.marginTop4
                              )}
                            >
                              <Typography
                                variant="h5"
                                className={classes.headline}
                              >
                                Phone Numbers
                              </Typography>
                            </div>
                          ))}
                        {/* {isNotMe &&
                        this.props.authenticatedUser.id &&
                        (!hidePhone ||
                          (this.props.activeCompany &&
                            this.props.activeCompany !== 3)) ? (
                          <Typography
                            gutterBottom
                            variant="caption"
                            className={classes.phone}
                          >
                            <a href={`tel:${user.phone}`}>
                              {user.formattedPhone}
                            </a>
                          </Typography>
                        ) : !this.props.authenticatedUser.id ? (
                          <Typography
                            gutterBottom
                            variant="caption"
                            className={classes.phone}
                            style={{ cursor: "pointer" }}
                            onClick={e => {
                              const id = this.props.user.id
                              this.handleClose()
                              hiddenLoginModal()
                                .then(() => {
                                  this.props.dispatch(
                                    toggleProfileDialog(true, {
                                      id,
                                    })
                                  )
                                })
                                .catch(err => {
                                  this.props.dispatch(
                                    toggleProfileDialog(true, {
                                      id,
                                    })
                                  )
                                })
                            }}
                          >
                            <a style={{ textDecoration: "underline" }}>
                              Login to see Contact info
                            </a>
                          </Typography>
                        ) : null} */}
                        {isNotMe &&
                          this.props.authenticatedUser.id &&
                          ((this.props.activeCompany &&
                            this.props.activeCompany === 2) ||
                            this.props.activeCompany === 3) && (
                            <Typography
                              gutterBottom
                              variant="caption"
                              className={classes.phone}
                            >
                              <a href={`tel:${user.phone}`}>
                                {user.formattedPhone}
                              </a>
                            </Typography>
                          )}
                        {(isMe || this.props.activeCompany === 3) && (
                          <div className={classes.toggleButtons}>
                            <PhoneInput
                              value={this.state.user.phone}
                              onChange={this.handlePhoneChange}
                              valid
                              label="Mobile Phone*"
                            />
                            <IconButton
                              style={{ marginLeft: "8px" }}
                              onClick={e =>
                                this.setState({ hidePhone: !hidePhone })
                              }
                            >
                              <Icon>
                                {!hidePhone
                                  ? "remove_red_eye"
                                  : "visibility_off"}
                              </Icon>
                            </IconButton>
                          </div>
                        )}
                        {!isEmpty(user) &&
                          user.phones
                            .filter(
                              x =>
                                isMe ||
                                this.props.activeCompany ||
                                hidePhones.indexOf(x.id) === -1
                            )
                            .map(phone => (
                              <div key={phone.id} className={classes.extraLine}>
                                <Typography
                                  variant="body2"
                                  className={classes.extraLineTypography}
                                >
                                  <a href={`tel:${phone.phone}`}>
                                    {phone.phone}
                                  </a>
                                </Typography>
                                {(isMe || this.props.activeCompany === 3) && (
                                  <div className={classes.toggleButtons}>
                                    <LoadingIconButton
                                      working={
                                        this.state.removingPhones.indexOf(
                                          phone.id
                                        ) > -1
                                      }
                                      buttonclicked={() =>
                                        this.removePhone(phone)
                                      }
                                      mergeclasses={classes.cancelIcon}
                                    >
                                      <Cancel />
                                    </LoadingIconButton>
                                    <IconButton
                                      style={{ marginLeft: "8px" }}
                                      onClick={e => {
                                        if (hidePhones.indexOf(phone.id) > -1) {
                                          this.setState({
                                            hidePhones: hidePhones.filter(
                                              x => x !== phone.id
                                            ),
                                          })
                                        } else {
                                          this.setState({
                                            hidePhones: hidePhones.concat(
                                              phone.id
                                            ),
                                          })
                                        }
                                      }}
                                    >
                                      <Icon>
                                        {user.phones.filter(
                                          x => hidePhones.indexOf(x.id) > -1
                                        ).length === 0
                                          ? "remove_red_eye"
                                          : "visibility_off"}
                                      </Icon>
                                    </IconButton>
                                  </div>
                                )}
                              </div>
                            ))}
                        {(isMe || this.props.activeCompany === 3) && (
                          <form
                            onSubmit={this.addNewPhone}
                            className={classes.inputWithAddButton}
                          >
                            <div className={classes.newInputWrapper}>
                              <PhoneInput
                                name="newPhone"
                                id="newPhone"
                                value={this.state.newPhone}
                                onChange={this.handleNewPhoneChange}
                                valid
                                label="Other Phone"
                              />
                            </div>
                            <div className={classes.addIcon}>
                              <LoadingIconButton
                                working={this.state.addingNewPhone}
                                type="submit"
                              />
                            </div>
                          </form>
                        )}
                        {isMe ||
                          (!isEmpty(user) &&
                            user.emails.filter(
                              x =>
                                isMe ||
                                this.props.activeCompany ||
                                hideEmails.indexOf(x.id) === -1
                            ).length > 0 && (
                              <div
                                className={classNames(
                                  classes.headlineWrapper,
                                  classes.marginTop4
                                )}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.headline}
                                >
                                  Emails
                                </Typography>
                              </div>
                            ))}

                        {(isMe || this.props.activeCompany === 3) && (
                          <FormControl fullWidth>
                            <div className={classes.toggleButtons}>
                              <TextField
                                type="text"
                                fullWidth
                                name="email"
                                label="Default Email"
                                value={
                                  this.state.user.email !== null
                                    ? this.state.user.email
                                    : ""
                                }
                                onChange={this.handleInputChange}
                                id="email"
                                autoComplete="nope"
                              />
                              <IconButton
                                style={{ marginLeft: "8px" }}
                                onClick={e =>
                                  this.setState({ hideEmail: !hideEmail })
                                }
                              >
                                <Icon>
                                  {!hideEmail
                                    ? "remove_red_eye"
                                    : "visibility_off"}
                                </Icon>
                              </IconButton>
                            </div>
                          </FormControl>
                        )}
                        {!isEmpty(user) &&
                          user.emails
                            .filter(
                              x =>
                                isMe ||
                                this.props.activeCompany ||
                                hideEmails.indexOf(x.id) === -1
                            )
                            .map((email, index) => (
                              <div key={email.id} className={classes.extraLine}>
                                <Typography
                                  variant="body2"
                                  className={classes.extraLineTypography}
                                >
                                  <a href={`mailto:${email.email}`}>
                                    {email.email}
                                  </a>
                                </Typography>
                                {(isMe || this.props.activeCompany === 3) && (
                                  <div className={classes.toggleButtons}>
                                    <LoadingIconButton
                                      working={
                                        this.state.removingEmails.indexOf(
                                          email.id
                                        ) > -1
                                      }
                                      buttonclicked={() =>
                                        this.removeEmail(email)
                                      }
                                      mergeclasses={classes.cancelIcon}
                                    >
                                      <Cancel />
                                    </LoadingIconButton>
                                    <IconButton
                                      style={{ marginLeft: "8px" }}
                                      onClick={e => {
                                        if (hideEmails.indexOf(email.id) > -1) {
                                          this.setState({
                                            hideEmails: hideEmails.filter(
                                              x => x !== email.id
                                            ),
                                          })
                                        } else {
                                          this.setState({
                                            hideEmails: hideEmails.concat(
                                              email.id
                                            ),
                                          })
                                        }
                                      }}
                                    >
                                      <Icon>
                                        {user.emails.filter(
                                          x => hideEmails.indexOf(x.id) > -1
                                        ).length === 0
                                          ? "remove_red_eye"
                                          : "visibility_off"}
                                      </Icon>
                                    </IconButton>
                                  </div>
                                )}
                              </div>
                            ))}
                        {(isMe || this.props.activeCompany === 3) && (
                          <form
                            onSubmit={this.addNewEmail}
                            className={classes.inputWithAddButton}
                          >
                            <div className={classes.newInputWrapper}>
                              <FormControl fullWidth>
                                <TextField
                                  type="email"
                                  fullWidth
                                  name="newEmail"
                                  label="Other Email"
                                  value={this.state.newEmail}
                                  onChange={this.handleNewInputChange}
                                  id="newEmail"
                                  autoComplete="nope"
                                />
                              </FormControl>
                            </div>
                            <LoadingIconButton
                              working={this.state.addingNewEmail}
                              type="submit"
                              mergeclasses={classes.addIcon}
                            />
                          </form>
                        )}
                        {isNotMe &&
                          this.props.authenticatedUser.id &&
                          this.props.activeCompany &&
                          (this.props.activeCompany === 2 ||
                            this.props.activeCompany === 3) && (
                            <Typography
                              gutterBottom
                              variant="caption"
                              className={classes.email}
                            >
                              <a href={`mailto:${user.email}`}>{user.email}</a>
                            </Typography>
                          )}
                        {(isMe || this.props.activeCompany === 3) && (
                          <FormControl className={classes.marginTop4}>
                            <Button
                              color="primary"
                              type="button"
                              onClick={this.openCreateCalendarDialog}
                            >
                              Google Calendar
                            </Button>
                          </FormControl>
                        )}
                        {isMe && (
                          <FormControl fullWidth className={classes.marginTop4}>
                            <Input
                              type="password"
                              fullWidth
                              name="password"
                              placeholder="New Password"
                              value={this.state.user.password}
                              onChange={this.handleInputChange}
                              id="password"
                              autoComplete="nope"
                            />
                          </FormControl>
                        )}
                        {isMe && (
                          <FormControl
                            fullWidth
                            className={classNames(
                              classes.marginTop4,
                              classes.marginBottom2
                            )}
                          />
                        )}
                        {isNotMe && (
                          <Typography
                            variant="caption"
                            className={this.props.classes.description}
                          >
                            {this.props.user.description}
                          </Typography>
                        )}
                        {(isMe ||
                          (isNotMe &&
                            (!isEmpty(user) && user.websites.length > 0))) && (
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop4
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Websites
                            </Typography>
                          </div>
                        )}
                        {!isEmpty(user) &&
                          user.websites.map(website => (
                            <div key={website.id} className={classes.extraLine}>
                              <Typography
                                variant="body2"
                                className={classes.extraLineTypography}
                              >
                                <a
                                  href={website.website}
                                  target="_blank"
                                  rel="nofollow"
                                >
                                  {website.website}
                                </a>
                              </Typography>
                              {isMe && (
                                <LoadingIconButton
                                  working={
                                    this.state.removingWebsites.indexOf(
                                      website.id
                                    ) > -1
                                  }
                                  buttonclicked={() =>
                                    this.removeWebsite(website)
                                  }
                                  mergeclasses={classes.cancelIcon}
                                >
                                  <Cancel />
                                </LoadingIconButton>
                              )}
                            </div>
                          ))}
                        {isMe && (
                          <form
                            onSubmit={this.addNewWebsite}
                            className={classes.inputWithAddButton}
                          >
                            <div className={classes.newInputWrapper}>
                              <FormControl fullWidth>
                                <TextField
                                  type="url"
                                  fullWidth
                                  name="newWebsite"
                                  label="New Website"
                                  value={this.state.newWebsite}
                                  onChange={this.handleNewInputChange}
                                  id="newWebsite"
                                  autoComplete="nope"
                                />
                              </FormControl>
                            </div>
                            <LoadingIconButton
                              working={this.state.addingNewWebsite}
                              type="submit"
                              mergeclasses={classes.addIcon}
                            />
                          </form>
                        )}
                        {/* social connect start */}
                        {networks &&
                          networks.length > 0 && (
                            <Fragment>
                              {(isMe || (isNotMe && !isEmpty(user))) && (
                                <div
                                  className={classNames(
                                    classes.headlineWrapper,
                                    classes.marginTop4
                                  )}
                                >
                                  <Typography
                                    variant="h5"
                                    className={classes.headline}
                                  >
                                    Linked Accounts
                                  </Typography>
                                </div>
                              )}
                              {isMe &&
                                !isEmpty(user) &&
                                isEmpty(user.networks) &&
                                networks.map((network, networkIndex) => {
                                  if (network.network === "twitter")
                                    return (
                                      <div
                                        className={classes.socialSwitchWrapper}
                                      >
                                        <TwitterIcon />
                                        <Button
                                          color="primary"
                                          type="button"
                                          onClick={event =>
                                            this.handleSocialConnectSwitch(
                                              event,
                                              network.network,
                                              network.id
                                            )
                                          }
                                        >
                                          Link Twitter
                                        </Button>
                                      </div>
                                    )
                                })}

                              {!isEmpty(user) &&
                                !isEmpty(user.networks) &&
                                !isEmpty(networks) &&
                                user.networks.map((network, networkIndex) => {
                                  if (network.id) {
                                    return (
                                      <div className={classes.switchWrapper}>
                                        <TwitterIcon
                                          className={classes.twitterIcon}
                                        />
                                        <Typography
                                          variant="p"
                                          className={classes.headline}
                                        >
                                          @{
                                            JSON.parse(network.authentication)
                                              .screen_name
                                          }
                                        </Typography>
                                      </div>
                                    )
                                  }
                                })}
                            </Fragment>
                          )}

                        {/* social connect end */}
                        {isMe && (
                          <AddressAutoComplete
                            className={classes.autoComplete}
                            value={
                              user.street_number
                                ? `${user.street_number} ${user.route} ${
                                    user.city
                                  }, ${user.state} ${user.zip}`
                                : undefined
                            }
                            InputProps={{ label: "Enter Billing Address" }}
                            InputClasses={{
                              input: classes.placesAutoCompleteInputInput,
                            }}
                            onChange={this.onAddressChange}
                          />
                        )}
                        {isNotMe &&
                          user.street_number && (
                            <Fragment>
                              <div
                                className={classNames(
                                  classes.headlineWrapper,
                                  classes.marginTop4
                                )}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.headline}
                                >
                                  Billing Address
                                </Typography>
                              </div>
                              <Typography variant="body2">
                                {user.street_number} {user.route}
                                <br /> {user.city}, {user.state} {user.zip}
                              </Typography>
                            </Fragment>
                          )}
                        {this.props.activeCompany === 3 && (
                          <div className={classes.switchWrapper}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={
                                    user.badges && user.badges.length > 0
                                  }
                                  onChange={this.handleEliteChanged}
                                  color="primary"
                                />
                              }
                              label="Elite"
                            />
                          </div>
                        )}
                        {this.props.activeCompany !== 3 &&
                          user.elite && (
                            <Typography
                              variant="body2"
                              className={classes.elite}
                            >
                              Elite<CheckCircle className={classes.eliteIcon} />
                            </Typography>
                          )}
                        {isMe && (
                          <div className={classes.switchWrapper}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={user.public}
                                  onChange={this.handlePublicChanged}
                                  color="primary"
                                />
                              }
                              label="Public Profile"
                            />
                            <InfoCircle>
                              Turning off Public Profile means only you and any
                              organizations that have your mobile number can see
                              your information.
                            </InfoCircle>
                          </div>
                        )}
                        {isMe && (
                          <div className={classes.switchWrapper}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={user.labor_only}
                                  onChange={this.handleLaborOnlyChanged}
                                  color="primary"
                                />
                              }
                              label="Labor Only"
                            />
                            <InfoCircle>
                              Labor Only allows managers to book you with out
                              any gear.
                            </InfoCircle>
                          </div>
                        )}
                        {isNotMe &&
                          user.labor_only && (
                            <Typography
                              variant="body2"
                              className={classes.laborOnly}
                            >
                              Labor Only<CheckCircle
                                className={classes.laborOnlyIcon}
                              />
                            </Typography>
                          )}
                        {isMe ||
                          ((this.props.activeCompany === 3 ||
                            this.props.activeCompany === 2) && (
                            <div className={classes.switchWrapper}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={user.vaccinated}
                                    onChange={this.handleVaccinatedChanged}
                                    color="primary"
                                  />
                                }
                                label="Vaccinated"
                              />
                              <InfoCircle>
                                Vaccinated means the person is Fully Vaccinated
                              </InfoCircle>
                            </div>
                          ))}
                        {isNotMe &&
                          user.vaccinated && (
                            <Typography
                              variant="body2"
                              className={classes.laborOnly}
                            >
                              Vaccinated<CheckCircle
                                className={classes.laborOnlyIcon}
                              />
                            </Typography>
                          )}
                      </Fragment>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      {(isMe || this.props.activeCompany === 3) && (
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        >
                          {isMe &&
                            !this.props.user.membershipValid &&
                            this.props.user.crew_company_id !== 3 && (
                              <Button
                                color="primary"
                                variant="contained"
                                style={{ height: "100%" }}
                                onClick={() => {
                                  this.props.dispatch({
                                    type: "PAYMENT_MODAL",
                                    payload: true,
                                  })
                                }}
                              >
                                Upgrade
                              </Button>
                            )}
                          <Box className={classes.connectStripeContainer}>
                            {this.state.user.stripe_account === 1 && (
                              <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center">
                                  <Typography style={{ color: "green" }}>
                                    Connected to Stripe
                                  </Typography>
                                  <FiberManualRecordIcon
                                    style={{ color: "green", fontSize: "12px" }}
                                  />
                                </Box>
                                {isMe && (
                                  <Button
                                    onClick={this.disconnectUserStripe}
                                    color="primary"
                                  >
                                    Disconnect Stripe
                                  </Button>
                                )}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      )}

                      <Hidden xsDown>
                        <div className={classes.tabs}>
                          <Tabs
                            value={this.state.activeTab}
                            classes={{ root: classes.tabsRoot }}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                          >
                            <Tab label="Details" className={classes.tab} />
                            <Tab
                              label="Reel"
                              className={classes.tab}
                              disabled={
                                isDisabled

                                // isNotMe &&
                                // this.props.activeCompany !== 3 &&
                                // !user.membershipValid
                              }
                            />
                            <Tab
                              label="Clients"
                              className={classes.tab}
                              disabled={
                                // isNotMe &&
                                // this.props.activeCompany !== 3 &&
                                // !user.membershipValid
                                isDisabled
                              }
                            />
                          </Tabs>
                          {isNotMe &&
                            !isNotInShoots &&
                            isNotInSolos && (
                              <div className={classes.tabButtonWrapper}>
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    if (
                                      this.props.activeCompany ||
                                      getCurrentHost() === "crewmama"
                                    ) {
                                      const newCrew = {
                                        id: user.id,
                                        first_name: user.first_name,
                                        last_name: user.last_name,
                                        profile_image: user.profile_image,
                                      }
                                      if (this.state.selectedRole) {
                                        newCrew.shootRole = this.state.selectedRole
                                        newCrew.shootRole.client_rate =
                                          newCrew.shootRole.rate
                                        newCrew.shootRole.crew_rate =
                                          Number(
                                            newCrew.shootRole.client_rate
                                          ) -
                                          Number(
                                            newCrew.shootRole.client_rate
                                          ) *
                                            0.12
                                        newCrew.shootRole.percentage = 12
                                        delete newCrew.shootRole.rate
                                      } else {
                                        newCrew.shootRole = null
                                      }

                                      this.props.dispatch(
                                        toggleShootDialog({ open: true })
                                      )
                                      this.props.dispatch(
                                        setShootDialogCrew([newCrew])
                                      )
                                    } else {
                                      if (isMe) {
                                        this.props.dispatch(
                                          openSnackBar({
                                            message: "You can't book yourself",
                                          })
                                        )
                                      } else {
                                        this.props.dispatch(
                                          toggleBookingDialog(true, user)
                                        )
                                      }
                                    }
                                  }}
                                  variant="contained"
                                >
                                  Book
                                </Button>
                              </div>
                            )}
                        </div>
                      </Hidden>
                      {(this.state.activeTab === 0 ||
                        this.props.width === "xs") && (
                        <Fragment>
                          <Hidden smUp>
                            <Typography
                              className={classes.sectionHeadline}
                              variant="h5"
                            >
                              Details
                            </Typography>
                          </Hidden>
                          <div className={classes.headlineWrapper}>
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Positions
                            </Typography>
                            {(isMe || this.shouldShowControls("roles")) &&
                              user.roles.length < 5 && (
                                <Button
                                  size="small"
                                  onClick={() =>
                                    this.setState({
                                      showAddPosition: !this.state
                                        .showAddPosition,
                                    })
                                  }
                                  className={classes.addButton}
                                  color="primary"
                                >
                                  {this.state.showAddPosition
                                    ? "Cancel"
                                    : "Add"}
                                </Button>
                              )}
                            {this.state.showAddPosition && (
                              <Button
                                size="small"
                                onClick={() =>
                                  this.props.dispatch(
                                    toggleSuggestPositionDialog()
                                  )
                                }
                                className={classes.addButton}
                                color="secondary"
                              >
                                Suggest
                              </Button>
                            )}
                          </div>
                          {this.state.showAddPosition && (
                            <form
                              onSubmit={this.savePosition}
                              className={classes.inputWrapper}
                            >
                              <AutoComplete
                                className={classNames(classes.autoComplete, {
                                  [classes.marginRight]: !(
                                    this.props.accessLevel === 1 &&
                                    user.id !== this.props.authenticatedUser.id
                                  ),
                                })}
                                // value={this.state.role}
                                caps
                                creatable={false}
                                InputClasses={{
                                  input: classes.autoCompleteInput,
                                }}
                                showValue
                                placeholder="Search Positions"
                                onChange={val =>
                                  this.onAutoCompleteChange(val, "role")
                                }
                                // suggestions={this.props.roles}
                                labelKey="name"
                                prop={this.props}
                              />
                              {/* {this.props.accessLevel === 1 &&
                                user.id !== this.props.authenticatedUser.id && (
                                  <TextField
                                    value={this.state.rate}
                                    autoComplete="nope"
                                    id="rate-input"
                                    placeholder="Rate"
                                    type="number"
                                    className={classes.input}
                                    onChange={e =>
                                      this.setState({ rate: e.target.value })
                                    }
                                  />
                                )} */}
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingPosition}
                                disabled={isEmpty(this.state.role)}
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.roles.length) > 0 && (
                            <Collapse
                              className={classes.collapse}
                              in={this.state.showPositions}
                              collapsedHeight="33px"
                              id="position-collapse"
                            >
                              {positionCollapse &&
                                positionCollapse.clientHeight > 33 && (
                                  <ArrowIcon
                                    onClick={() =>
                                      this.setState({
                                        showPositions: !this.state
                                          .showPositions,
                                      })
                                    }
                                    className={classNames(
                                      this.props.classes.arrowIcon,
                                      {
                                        [this.props.classes.arrowDown]: this
                                          .state.showPositions,
                                      }
                                    )}
                                  />
                                )}
                              <div className={classes.chipWrapper}>
                                {!isEmpty(user) &&
                                  user.roles
                                    .sort((a, b) => a.id - b.id)
                                    .map((role, i) => {
                                      // logic for subscribed user
                                      if (
                                        this.props.activeCompany === 3 ||
                                        this.props.activeCompany === 2 ||
                                        i < 2 ||
                                        this.props.user.membershipValid
                                      ) {
                                        return (
                                          <PositionChip
                                            key={role.id}
                                            position={role.name}
                                            rate={
                                              role.company_id ===
                                                this.props.activeCompany &&
                                              this.props.accessLevel === 1
                                                ? role.rate
                                                : null
                                            }
                                            innerRef=""
                                            provided=""
                                            canRemove={
                                              isMe ||
                                              this.shouldShowControls("roles")
                                            }
                                            onDelete={() =>
                                              this.onDelete(role, "roles")
                                            }
                                          />
                                        )
                                      } else {
                                        return null
                                      }
                                    })}
                              </div>
                            </Collapse>
                          )}
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop3
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Local Cities
                            </Typography>
                            {(isMe || this.shouldShowControls("locations")) &&
                              user.locations.length < 5 && (
                                <React.Fragment>
                                  <Button
                                    size="small"
                                    onClick={() =>
                                      this.setState({
                                        showAddLocation: !this.state
                                          .showAddLocation,
                                      })
                                    }
                                    className={classes.addButton}
                                    color="primary"
                                  >
                                    {this.state.showAddLocation
                                      ? "Cancel"
                                      : "Add"}
                                  </Button>
                                  <InfoIcon text="Only select cities where you work local without travel expenses" />
                                </React.Fragment>
                              )}
                          </div>
                          {this.state.showAddLocation && (
                            <form
                              onSubmit={this.saveLocation}
                              className={classes.inputWrapper}
                            >
                              <PlacesAutoComplete
                                className={classes.autoComplete}
                                value={this.state.location}
                                InputProps={{ placeholder: "Enter City" }}
                                InputClasses={{
                                  input: classes.placesAutoCompleteInputInput,
                                }}
                                onChange={this.onPlacesChange}
                              />
                              <AutoComplete
                                id="radius-input"
                                className={classNames(
                                  classes.input,
                                  classes.inputMarginBottom
                                )}
                                value={this.state.radius}
                                caps
                                // InputClasses={{
                                //   input: classes.autoCompleteInput
                                // }}
                                showValue
                                placeholder="Radius"
                                onChange={val => {
                                  this.setState({
                                    radius: radiusSuggestions.find(
                                      x => x.id === val
                                    ),
                                  })
                                }}
                                defaultOptions={radiusSuggestions.map(x => {
                                  x.name = x.name.toString()
                                  return x
                                })}
                                labelKey="name"
                                openMenuOnClick={true}
                              />
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingLocation}
                                disabled={
                                  isEmpty(this.state.location) ||
                                  !this.state.radius
                                }
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.locations.length) > 0 && (
                            //logic for Subscribed user
                            <div className={classes.citiesWrapper}>
                              {!isEmpty(user) &&
                                user.locations.map((pos, i) => {
                                  if (
                                    this.props.user.membershipValid ||
                                    this.props.activeCompany === 3 ||
                                    i < 2
                                  ) {
                                    return (
                                      <MapCard
                                        key={pos.id}
                                        location={pos}
                                        canRemove={
                                          isMe ||
                                          this.shouldShowControls("locations")
                                        }
                                        onRemove={() =>
                                          this.onDelete(pos, "locations")
                                        }
                                      />
                                    )
                                  } else {
                                    return null
                                  }
                                })}
                            </div>
                          )}
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop3
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Equipment
                            </Typography>
                            {(isMe || this.shouldShowControls("equipment")) && (
                              <Button
                                size="small"
                                onClick={() =>
                                  this.setState({
                                    showAddEquipment: !this.state
                                      .showAddEquipment,
                                  })
                                }
                                className={classes.addButton}
                                color="primary"
                              >
                                {this.state.showAddEquipment ? "Cancel" : "Add"}
                              </Button>
                            )}
                          </div>
                          {this.state.showAddEquipment && (
                            <form
                              onSubmit={this.saveEquipment}
                              className={classes.inputWrapper}
                            >
                              <AutoComplete
                                className={classNames(
                                  classes.autoComplete,
                                  classes.marginRight
                                )}
                                value={this.state.equipment}
                                caps
                                creatable
                                InputClasses={{
                                  input: classes.autoCompleteInput,
                                }}
                                showValue
                                placeholder="Search Equipment"
                                onChange={val =>
                                  this.onAutoCompleteChange(val, "equipment")
                                }
                                suggestions={this.props.equipment}
                                labelKey="name"
                                prop={this.props}
                              />
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingEquipment}
                                disabled={isEmpty(this.state.equipment)}
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.equipment.length) > 0 && (
                            <Collapse
                              className={classes.collapse}
                              in={this.state.showEquipment}
                              collapsedHeight="33px"
                              id="equipment-collapse"
                            >
                              {equipmentCollapse &&
                                equipmentCollapse.clientHeight > 33 && (
                                  <ArrowIcon
                                    onClick={() =>
                                      this.setState({
                                        showEquipment: !this.state
                                          .showEquipment,
                                      })
                                    }
                                    className={classNames(
                                      this.props.classes.arrowIcon,
                                      {
                                        [this.props.classes.arrowDown]: this
                                          .state.showEquipment,
                                      }
                                    )}
                                  /> //logic for subscribed user
                                )}
                              {/* <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable
                                  droppableId="droppable"
                                  direction="horizontal"
                                >
                                  {(provided, snapshot) => ( */}
                              <div
                                className={classes.chipWrapper}
                                // ref={provided.innerRef}
                              >
                                {!isEmpty(user) &&
                                  user.equipment
                                    // .sort(
                                    //   (a, b) =>
                                    //     (a.position === null
                                    //       ? Infinity
                                    //       : a.position) -
                                    //     (b.position === null
                                    //       ? Infinity
                                    //       : b.position)
                                    // )
                                    .map((equipment, i) => {
                                      if (
                                        this.props.user.membershipValid ||
                                        this.props.activeCompany === 3 ||
                                        i < 6
                                      ) {
                                        return (
                                          // <Draggable
                                          //   key={equipment.id}
                                          //   draggableId={equipment.id.toString()}
                                          //   index={i}
                                          // >
                                          //   {(provided, snapshot) => (
                                          <span>
                                            <PositionChip
                                              ContainerComponent="div"
                                              // ContainerProps={{
                                              //   ref: provided.innerRef,
                                              // }}
                                              // {...provided.draggableProps}
                                              // {...provided.dragHandleProps}
                                              key={equipment.id}
                                              position={equipment.name}
                                              canRemove={
                                                isMe ||
                                                this.shouldShowControls(
                                                  "equipment"
                                                )
                                              }
                                              onDelete={() =>
                                                this.onDelete(
                                                  equipment,
                                                  "equipment"
                                                )
                                              }
                                            />
                                          </span>

                                          // <div
                                          //   role="button"
                                          //   className={classNames(
                                          //     classes.chipRoot,
                                          //     classes.chip
                                          //   )}
                                          //   tabIndex={-1}
                                          //   // ref={provided.innerRef}
                                          //   // {...provided.draggableProps}
                                          //   // {...provided.dragHandleProps}
                                          // >
                                          //   <span
                                          //     className={classNames(
                                          //       classes.chipLabel
                                          //     )}
                                          //   >
                                          //     {equipment.name}
                                          //   </span>
                                          //   {isMe ||
                                          //     (this.shouldShowControls(
                                          //       "equipment"
                                          //     ) && (
                                          //       <CancelIcon
                                          //         className={classes.deleteIcon}
                                          //         onTouchEnd={() =>
                                          //           this.onDelete(
                                          //             equipment,
                                          //             "equipment"
                                          //           )
                                          //         }
                                          //         onClick={() =>
                                          //           this.onDelete(
                                          //             equipment,
                                          //             "equipment"
                                          //           )
                                          //         }
                                          //       />
                                          //     ))}
                                          // </div>
                                          //   )}
                                          // </Draggable>
                                        )
                                      } else {
                                        return null
                                      }
                                    })}
                              </div>
                              {/* )}
                                </Droppable>
                              </DragDropContext> */}
                            </Collapse>
                          )}
                          {isNotMe &&
                            this.props.accessLevel === 1 && (
                              <Fragment>
                                <div
                                  className={classNames(
                                    classes.headlineWrapper,
                                    classes.marginTop3
                                  )}
                                >
                                  <Typography
                                    variant="h5"
                                    className={classes.headline}
                                  >
                                    Notes
                                  </Typography>
                                </div>
                                <div className={classes.noteArea}>
                                  {(!isEmpty(user) && user.notes.length) > 0 &&
                                    user.notes.map((note, i) => (
                                      <div
                                        key={note.id}
                                        className={classNames(classes.note, {
                                          [classes.lastNote]:
                                            i + 1 === user.notes.length,
                                        })}
                                      >
                                        <div className={classes.noteContent}>
                                          <div
                                            className={classes.noteFirstLine}
                                          >
                                            <MessageIcon
                                              className={
                                                classes.noteMessageIcon
                                              }
                                            />
                                            <Typography
                                              component="p"
                                              className={classes.noteLineText}
                                            >
                                              Note
                                            </Typography>
                                            <span
                                              className={classes.noteBullet}
                                            >
                                              &bull;
                                            </span>
                                            <Typography
                                              component="span"
                                              className={classes.noteTimeAgo}
                                            >
                                              {Moment(note.created)
                                                .utc()
                                                .from(Moment())}
                                            </Typography>
                                            {note.creator_id ===
                                              this.props.authenticatedUser.id &&
                                              this.state.editingNote !==
                                                note.id && (
                                                <KeyboardArrowDown
                                                  onClick={
                                                    this.handleOpenNoteMenu
                                                  }
                                                  className={
                                                    classes.noteLineArrowIcon
                                                  }
                                                />
                                              )}
                                            <Menu
                                              className={classes.noteMenu}
                                              id="note-menu"
                                              anchorEl={noteMenuAnchorEl}
                                              open={Boolean(noteMenuAnchorEl)}
                                              onClose={this.handleCloseNoteMenu}
                                              getContentAnchorEl={null}
                                              anchorOrigin={{
                                                vertical: "center",
                                                horizontal: "right",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "left",
                                              }}
                                            >
                                              <MenuItem
                                                onClick={() =>
                                                  this.handleNoteMenuItemClick(
                                                    "edit",
                                                    note
                                                  )
                                                }
                                              >
                                                Edit
                                              </MenuItem>
                                              <MenuItem
                                                onClick={() =>
                                                  this.handleNoteMenuItemClick(
                                                    "delete",
                                                    note
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Menu>
                                          </div>
                                          {this.state.editingNote !==
                                            note.id && (
                                            <Typography
                                              compontent="span"
                                              className={classes.noteSecondLine}
                                            >
                                              {note.creator_first_name}{" "}
                                              {note.creator_last_name}
                                            </Typography>
                                          )}
                                          {this.state.editingNote ===
                                            note.id && (
                                            <div
                                              className={classNames(
                                                classes.notesInputWrapper,
                                                classes.marginTop
                                              )}
                                            >
                                              <TextField
                                                value={this.state.noteEdits}
                                                id="note-input"
                                                placeholder="add note..."
                                                type="text"
                                                multiline
                                                fullWidth
                                                InputProps={{
                                                  classes: {
                                                    underline:
                                                      classes.noteInputUnderline,
                                                  },
                                                }}
                                                className={classes.noteInput}
                                                onChange={e =>
                                                  this.setState({
                                                    noteEdits: e.target.value,
                                                  })
                                                }
                                              />
                                              <div>
                                                <Button
                                                  type="button"
                                                  color="primary"
                                                  onClick={() =>
                                                    this.handleNoteMenuItemClick(
                                                      "cancelEdit"
                                                    )
                                                  }
                                                >
                                                  Cancel
                                                </Button>
                                                <LoadingButton
                                                  color="primary"
                                                  size="small"
                                                  className={
                                                    classes.saveNoteButton
                                                  }
                                                  buttonclicked={
                                                    this.updateNote
                                                  }
                                                  working={
                                                    this.state.updatingNote
                                                  }
                                                  disabled={
                                                    this.state.noteEdits ===
                                                    note.note
                                                  }
                                                  type="button"
                                                >
                                                  Save
                                                </LoadingButton>
                                              </div>
                                            </div>
                                          )}
                                          {this.state.editingNote !==
                                            note.id && (
                                            <Typography
                                              component="p"
                                              className={classes.noteNote}
                                            >
                                              {note.note}
                                            </Typography>
                                          )}
                                        </div>
                                        {this.state.editingNote !== note.id &&
                                          note.creator_first_name &&
                                          note.creator_last_name && (
                                            <CircleAvatar
                                              className={classes.circleAvatar}
                                              image={note.creator_profile_image}
                                            >
                                              {note.creator_first_name.charAt(
                                                0
                                              )}
                                              {note.creator_last_name.charAt(0)}
                                            </CircleAvatar>
                                          )}
                                      </div>
                                    ))}
                                  <div className={classes.notesInputWrapper}>
                                    <TextField
                                      value={this.state.note}
                                      id="note-input"
                                      placeholder="add note..."
                                      type="text"
                                      multiline
                                      fullWidth
                                      InputProps={{
                                        classes: {
                                          underline: classes.noteInputUnderline,
                                        },
                                      }}
                                      className={classes.noteInput}
                                      onChange={e =>
                                        this.setState({ note: e.target.value })
                                      }
                                    />
                                    <LoadingButton
                                      color="primary"
                                      size="small"
                                      className={classes.saveNoteButton}
                                      buttonclicked={this.saveNote}
                                      working={this.state.savingNote}
                                      disabled={
                                        isEmpty(this.state.note) ||
                                        !this.state.note
                                      }
                                      type="button"
                                    >
                                      Save
                                    </LoadingButton>
                                  </div>
                                </div>
                              </Fragment>
                            )}
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop3
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Vehicle
                            </Typography>
                            {(isMe || this.shouldShowControls("vehicles")) &&
                              user.vehicles.length < 5 && (
                                <Button
                                  size="small"
                                  onClick={() =>
                                    this.setState({
                                      showAddVehicle: !this.state
                                        .showAddVehicle,
                                    })
                                  }
                                  className={classes.addButton}
                                  color="primary"
                                >
                                  Add
                                </Button>
                              )}
                          </div>
                          {this.state.showAddVehicle && (
                            <form
                              onSubmit={this.saveVehicle}
                              className={classes.inputWrapper}
                            >
                              <TextField
                                value={this.state.vehicle.make}
                                autoComplete="nope"
                                name="make"
                                id="make-input"
                                placeholder="Make"
                                type="text"
                                onChange={this.updateVehicle}
                              />
                              <TextField
                                value={this.state.vehicle.model}
                                autoComplete="nope"
                                name="model"
                                id="model-input"
                                placeholder="Model"
                                type="text"
                                className={classes.input}
                                onChange={this.updateVehicle}
                              />
                              <TextField
                                value={this.state.vehicle.year}
                                autoComplete="nope"
                                name="year"
                                id="year-input"
                                placeholder="Year"
                                type="number"
                                className={classes.marginRight}
                                onChange={this.updateVehicle}
                              />
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingVehicle}
                                disabled={
                                  !this.state.vehicle.make ||
                                  !this.state.vehicle.model ||
                                  !this.state.vehicle.year
                                }
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.vehicles.length) > 0 &&
                            user.vehicles.map((vehicle, i) => {
                              if (
                                this.props.user.membershipValid ||
                                this.props.activeCompany === 3 ||
                                i < 1
                              ) {
                                return (
                                  <VehicleCard
                                    key={vehicle.id}
                                    vehicle={vehicle}
                                    user={user}
                                    className={classes.vehicle}
                                    canControl={
                                      isMe ||
                                      this.shouldShowControls("vehicles")
                                    }
                                  />
                                )
                              } else {
                                return null
                              }
                            })}
                          {isMe ||
                            (this.props.activeCompany === 3 && (
                              <div className={classes.descriptionWrapper}>
                                <InputLabel htmlFor="description">
                                  Description
                                </InputLabel>
                                <Input
                                  multiline
                                  rowsMax="8"
                                  type="text"
                                  fullWidth
                                  name="description"
                                  value={this.state.user.description}
                                  onChange={this.handleInputChange}
                                  id="description"
                                  autoComplete="nope"
                                />
                              </div>
                            ))}
                          <Typography variant="h5" className={classes.headline}>
                            Reel
                          </Typography>
                          {user.video && (
                            <Fragment>
                              <div
                                style={{
                                  padding: "56.25% 0 0 0",
                                  position: "relative",
                                }}
                              >
                                <iframe
                                  title="vimeo-player"
                                  src={`https://player.vimeo.com/video/${
                                    this.props.user.video
                                  }?title=0&byline=0&portrait=0`}
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  frameBorder="0"
                                />
                              </div>
                              <script src="https://player.vimeo.com/api/player.js" />
                            </Fragment>
                          )}
                        </Fragment>
                      )}

                      {(this.state.activeTab === 1 ||
                        this.props.width === "xs") && (
                        <Fragment>
                          <Hidden smUp>
                            <Typography
                              className={classes.sectionHeadline}
                              variant="h5"
                            >
                              Reel/Images
                            </Typography>
                          </Hidden>
                          {(isMe ||
                            this.props.activeCompany === 3 ||
                            this.props.activeCompany === 2) && (
                            <div className={this.props.classes.vimeoWrapper}>
                              <Typography
                                variant="subtitle1"
                                className={this.props.classes.vimeoLabel}
                              >
                                https://vimeo.com/
                              </Typography>
                              <FormControl
                                fullWidth
                                className={classes.marginBottom}
                              >
                                <Input
                                  type="text"
                                  fullWidth
                                  name="video"
                                  value={this.state.user.video}
                                  onChange={this.handleInputChange}
                                  inputProps={{
                                    pattern: /^\d+$/,
                                  }}
                                  id="video"
                                  autoComplete="nope"
                                />
                              </FormControl>
                            </div>
                          )}
                          {user.video && (
                            <Fragment>
                              <div
                                style={{
                                  padding: "56.25% 0 0 0",
                                  position: "relative",
                                }}
                              >
                                <iframe
                                  title="vimeo-player"
                                  src={`https://player.vimeo.com/video/${
                                    this.props.user.video
                                  }?title=0&byline=0&portrait=0`}
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  frameBorder="0"
                                />
                              </div>
                              <script src="https://player.vimeo.com/api/player.js" />
                            </Fragment>
                          )}
                          {(isMe ||
                            this.props.activeCompany === 3 ||
                            this.props.activeCompany === 2) && (
                            <div
                              className={classNames(
                                classes.headlineWrapper,
                                classes.marginTop3
                              )}
                            >
                              <Typography
                                variant="h5"
                                className={classes.headline}
                              >
                                Image Gallery
                              </Typography>
                              {(isMe ||
                                this.props.activeCompany === 3 ||
                                this.props.activeCompany === 2) && (
                                <Button
                                  size="small"
                                  color="primary"
                                  onClick={this.clickGalleryImageInput}
                                >
                                  Add
                                </Button>
                              )}
                              <input
                                type="file"
                                id="galleryImage"
                                name="galleryImage"
                                className={classes.avatarInput}
                                value={this.state.galleryImage}
                                onChange={this.galleryUpload}
                              />
                            </div>
                          )}
                          <div className={classes.galleryWrapper}>
                            {user.gallery.map((image, i) => (
                              <Paper
                                key={image.id}
                                eleation={2}
                                onClick={() => this.openGallery(i)}
                                className={classes.galleryPaper}
                              >
                                {(isMe ||
                                  this.props.activeCompany === 3 ||
                                  this.props.activeCompany === 2) && (
                                  <div className={classes.removeIconWrapper}>
                                    <Cancel
                                      onClick={() =>
                                        this.removeGalleryImage(image)
                                      }
                                      className={classes.removeIcon}
                                    />
                                  </div>
                                )}
                                <img
                                  className={this.props.classes.galleryThumb}
                                  src={`https://res.cloudinary.com/${
                                    process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                                  }/image/upload/c_thumb,g_auto,h_400,w_400,fl_lossy,f_auto/v${
                                    image.image.version
                                  }/${image.image.public_id}.${
                                    image.image.format
                                  }`}
                                  alt={`gallery ${image.id}`}
                                />
                              </Paper>
                            ))}
                          </div>
                        </Fragment>
                      )}
                      {(this.state.activeTab === 2 ||
                        this.props.width === "xs") && (
                        <Fragment>
                          <Hidden smUp>
                            <Typography
                              className={classes.sectionHeadline}
                              variant="h5"
                            >
                              Clients
                            </Typography>
                          </Hidden>
                          {(isMe || this.props.activeCompany === 3) && (
                            <Editor
                              toolbar={toolBar}
                              editorState={this.state.clientsEditorContent}
                              onEditorStateChange={this.onEditorStateChange}
                            />
                          )}
                          {isNotMe && (
                            <div
                              dangerouslySetInnerHTML={{ __html: user.clients }}
                            />
                          )}
                        </Fragment>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions
                  className={classes.dialogActions}
                  // classes={{
                  //   action: classes.dialogActionsAction
                  // }}
                >
                  <Button
                    color="primary"
                    onClick={this.handleClose}
                    type="button"
                  >
                    Close
                  </Button>

                  {(isMe || this.props.activeCompany === 3) && (
                    <Fragment>
                      <LoadingButton
                        color="secondary"
                        buttonclicked={this.submit}
                        working={this.state.savingProfile}
                        disabled={
                          (!isEmpty(user)
                            ? isEmpty(this.getDiff())
                            : !isEmpty(this.state.form) &&
                              !this.state.form.valid) ||
                          this.state.savingAndCloseProfile
                        }
                        type="button"
                      >
                        Save
                      </LoadingButton>
                    </Fragment>
                  )}
                </DialogActions>
              </Fragment>
            )}
          {!isEmpty(user) &&
            Object.keys(user).length === 1 && (
              <LoadingIndicator working={true}>
                Loading Crew Profile
              </LoadingIndicator>
            )}
        </Dialog>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          className={classes.galleryModal}
          open={this.state.galleryOpen}
          onClose={() => this.setState({ galleryOpen: false })}
        >
          <div className={this.props.classes.modal}>
            {!isEmpty(user) &&
              Object.keys(user).length > 1 && (
                <ImageGallery
                  ref={i => (this._imageGallery = i)}
                  items={user.gallery.map(g => ({
                    original: `https://res.cloudinary.com/${
                      process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                    }/image/upload/fl_lossy,f_auto/v${g.image.version}/${
                      g.image.public_id
                    }.${g.image.format}`,
                    thumbnail: `https://res.cloudinary.com/${
                      process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                    }/image/upload/c_thumb,g_auto,h_400,w_400,fl_lossy,f_auto/v${
                      g.image.version
                    }/${g.image.public_id}.${g.image.format}`,
                  }))}
                />
              )}
          </div>
        </Modal>
        {(isMe || this.props.activeCompany === 3) && (
          <CreateCalendarDialog
            profileProps={this.state}
            setCanCreateCalendar={bool =>
              this.setState({ canCreateCalendar: bool })
            }
            removeEmail={this.removeEmail}
            hideOtherEmail={this.hideOtherEmail}
            updateHiddenFields={this.submit}
          />
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    profileDialogOpen: state.users.profileDialogOpen,
    user: state.users.editUser,
    roles: state.misc.roles,
    locations: state.misc.locations,
    equipment: state.misc.equipment,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    networks: state.misc.networks,
  }
}

export default compose(
  connect(mapStateToProps),
  withMobileDialog(),
  withWidth(),
  // withTheme(),
  withStyles(styles)
)(ProfileDialogComponent)
